function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.424 17h-9.85C2.048 17 0 14.951 0 12.424V4.573C0 2.047 2.048-.001 4.574-.001h9.85c2.526 0 4.574 2.048 4.574 4.574v7.851c0 2.527-2.048 4.576-4.574 4.576zm3.073-5.21V4.573c0-1.695-1.378-3.074-3.073-3.074h-9.85C2.879 1.499 1.5 2.878 1.5 4.573v7.851c0 1.696 1.379 3.075 3.074 3.075h9.85c1.695 0 3.073-1.379 3.073-3.075v-.634zm-4.003-3.149h-1.436c-.431 0-.782-.35-.782-.782 0-.43.351-.781.782-.781h1.436c.432 0 .782.351.782.781 0 .432-.35.782-.782.782zm-4 0H5.058c-.432 0-.782-.35-.782-.782 0-.43.35-.781.782-.781h4.436c.431 0 .782.351.782.781 0 .432-.351.782-.782.782z"
});

var SvgCreditCard = function SvgCreditCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreditCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/credit-card.4a1e5a4a.svg";
export { ForwardRef as ReactComponent };